import React, { useEffect, useState } from "react";
import ScrapingService from "../services/scraping.service";

const useScrapingUsage = (provider) => {
    const [usage, setUsage] = useState(null);
    const [loading, setLoading] = useState(false);

    const fetchUsage = async () => {
        setLoading(true);
        const response = await ScrapingService.getUsage(provider);
        setUsage(response.data);
        setLoading(false);
    };

    useEffect(() => {
        if (provider) {
            fetchUsage();
        }
    }, [provider]);
    return { usage, loading, fetchUsage };
};

export default useScrapingUsage;